import { render } from "./TooltipModal.vue?vue&type=template&id=5d9716e4"
import script from "./TooltipModal.vue?vue&type=script&lang=js"
export * from "./TooltipModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__